const Telugu = {
  // COMMON
  language: "భాష",
  changeLanguage: "భాష మార్చండి",
  date: "తేదీ",
  time: "సమయం",
  price: "ధర",
  month: "నెల",
  nearbyTemples: "సమీపంలోని దేవాలయాలు",
  createTemples: "దేవాలయాలను సృష్టించండి",
  temples: "దేవాలయాలు",
  latestTemples: "తాజా దేవాలయాలు",
  groupOfTemples: "దేవాలయాల సమూహం",
  // menus
  dashboard: "డ్యాష్‌బోర్డ్",
  admission: "ప్రవేశం",
  report: "నివేదిక",
  timeTable: "సమయ పట్టిక",
  messaging: "సందేశాలు",
  events: "ఈవెంట్లు",
  master: "మాస్టర్",
  exam: "పరీక్ష",
  download: "డౌన్‌లోడ్",
  attendanceDashboard: "హాజరు డ్యాష్‌బోర్డ్",
  //DASHBOARD
  templeCreateDescription:
    "ఒక దేవాలయ ప్రొఫైల్ సృష్టించడం సులభం, అర్థవంతమైనది మరియు ఉచితం. మీ దేవాలయ కథ ఇతరులను ప్రేరేపించనివ్వండి మరియు పెరుగుతున్న ఆధ్యాత్మిక నెట్‌వర్క్‌లో భాగం అవ్వండి.",

  backToSearch: "శోధనకు తిరిగి వెళ్ళు",
  backToDashboard: "డ్యాష్‌బోర్డ్‌కు తిరిగి వెళ్ళు",
  templeView: "దేవాలయ వీక్షణ",
  editTemples: "దేవాలయాలను సవరించండి",
  backToTemples: "దేవాలయాలకు తిరిగి వెళ్ళు",
  profile: "ప్రొఫైల్",
  personalInfo: "వ్యక్తిగత సమాచారం",
  locationBackground: "స్థానం & నేపథ్యం",
  spiritualIdentification: "ఆధ్యాత్మిక & గుర్తింపు",
  editProfile: "ప్రొఫైల్ సవరించండి",
  profilePhoto: "ప్రొఫైల్ ఫోటో",
  backToProfile: "ప్రొఫైల్‌కు తిరిగి వెళ్ళు",
  saveProfile: "ప్రొఫైల్ సేవ్ చేయండి",
  optional: "(ఐచ్చికం)",

  // TEMPLE
  mainDeity: "ప్రధాన దేవుడు",
  otherDeity: "ఇతర దేవతలు",
  location: "స్థానం",
  address: "చిరునామా",
  city: "నగరం",
  district: "జిల్లా",
  state: "రాష్ట్రం",
  country: "దేశం",
  pincode: "పిన్ కోడ్",
  geographicCoordinates: "భౌగోళిక సమన్వయాలు",
  cityTownVillage: "నగరం / పట్టణం / గ్రామం",

  availableFacilities: "లభ్యమైన సౌకర్యాలు & యాక్సెస్",
  ritualsGuidelines: "ఆచార మార్గదర్శకాలు",
  dressCode: "డ్రెస్ కోడ్",
  festivalEvents: "పండగలు & ఈవెంట్స్",
  poojaDetails: "పూజా వివరాలు",
  contactInfo: "సంప్రదింపు సమాచారం",
  templeTimings: "దేవాలయ సమయాలు",
  morning: "ఉదయం",
  afternoon: "మధ్యాహ్నం",
  sthalaVirutcham: "స్థల విరుచ్చం",
  bestTime: "సందర్శనకు ఉత్తమ సమయం",
  atonementRituals: "ఈ దేవాలయంలో ప్రాయశ్చిత్త ఆచారాలు",
  howToReach: "ఎలా చేరుకోవాలి",
  km: "కిమీ",
  ownershipDetails: "దేవాలయ స్వంత హక్కుల వివరాలు",
  managedBy: "వలన నిర్వహించబడుతుంది",

  //TEMPLE CONTACT
  templeGallery: "గుడి గ్యాలరీ",
  templeEmail: "గుడి ఈమెయిల్ చిరునామా",
  templeOwnershipContact: "గుడి యాజమాన్యం సంప్రదింపు సమాచారం",
  otherContactInfo: "ఇతర సంప్రదింపు సమాచారం",

  // REVIEWS
  reviews: "సమీక్షలు",
  communityReviews: "మన సమాజం నుండి సమీక్షలు",
  searchReviews: "సమీక్షలను వెతకండి",
  reviewDetails: "సమీక్ష వివరాలు",
  review: "సమీక్ష",
  noReviews: "మీ ఆలయ అనుభవాన్ని పంచుకునే మొదటి వ్యక్తిగా ఉండండి.",

  // EXPERIENCES
  userExperience: "అనుభవాలు",
  shareYourExperience: "మీ అనుభవాన్ని పంచుకోండి",
  communityExperiences: "మా సమాజంలోని అనుభవాలు",
  searchExperiences: "అనుభవాలను వెతకండి",
  experienceDetails: "అనుభవ వివరాలు",
  search: "వెతకండి",

  // SUGGESTIONS
  suggestUpdate: "అప్‌డేట్ సూచించండి",
  helpImprove1: "మేము మిస్ చేసిన ఏదైనా విషయం మీకు తెలుసా",
  helpImprove2:
    "సమాచారాన్ని ఖచ్చితంగా మరియు నవీకరించబడినదిగా ఉంచడానికి మీ సూచనలను పంచుకోండి.",
  suggestion: "సూచన",
  referenceLink: "రెఫరెన్స్ లింక్",
  otherGroupTemples: "ఈ గ్రూప్‌లోని ఇతర దేవాలయాలు",

  // BUTTONS
  viewAllTemples: "అన్ని దేవాలయాలను వీక్షించండి",
  getDirection: "దిశ పొందండి",
  website: "దేవాలయ వెబ్‌సైట్",
  writeReview: "సమీక్ష రాయండి",
  addSuggestion: "సూచన జోడించండి",
  next: "తదుపరి",
  previous: "మునుపటి",
  cancel: "రద్దు చేయండి",
  submit: "సమర్పించండి",
  updatePassword: "పాస్వర్డ్ నవీకరించండి",
  updateNow: "ఇప్పుడు నవీకరించండి",

  // INPUT
  name: "పేరు",
  phoneNumber: "ఫోన్ నంబర్",
  mobileNumber: "మొబైల్ నంబర్",
  // PROFILE
  currentPassword: "ప్రస్తుత పాస్వర్డ్",
  newPassword: "కొత్త పాస్వర్డ్",
  confirmNewPassword: "కొత్త పాస్వర్డ్ నిర్ధారించండి",
  firstName: "మొదటి పేరు",
  middleName: "మధ్య పేరు",
  lastName: "చివరి పేరు",
  fullName: "పూర్తి పేరు",
  fatherName: "తండ్రి పేరు",
  motherName: "తల్లి పేరు",
  dateOfBirth: "పుట్టిన తేది",
  age: "వయసు",
  gender: "లింగం",
  email: "ఈమెయిల్ చిరునామా",
  phone: "ఫోన్ నంబర్",
  bio: "జీవితచరిత్ర",
  religion: "మతం",
  visitFrequency: "సందర్శన తరచుదనం",
  maritalStatus: "వివాహ స్థితి",
  aadhaarNumber: "ఆధార్ నంబర్",
  panNumber: "పాన్ నంబర్",
  passportNumber: "పాస్పోర్ట్ నంబర్",
  occupation: "వృత్తి",
  bloodGroup: "రక్తపు గ్రూప్",

  // EMPTY
  noGuidelines: "మార్గదర్శకాలు అందుబాటులో లేవు.",
  noDressCode: "డ్రెస్ కోడ్ డేటా అందుబాటులో లేదు.",
  noAtonementRituals: "ఈ దేవాలయంలో ప్రాయశ్చిత్త ఆచారాలు లేవు.",
  noTransport: "ఎడ్జినీటీ ట్రాన్స్‌పోర్ట్ ఆప్షన్స్ అందుబాటులో లేవు.",
  noFestivalEvents: "ఏ పండుగ లేదా ఈవెంట్ డేటా అందుబాటులో లేదు",
  noPoojaData: "పూజా డేటా అందుబాటులో లేదు",
  noOwnershipData: "యాజమాన్యం డేటా అందుబాటులో లేదు",
  noContactData: "సంప్రదింపు డేటా అందుబాటులో లేదు",
  noTempleImages: "దేవాలయ చిత్రాలు అందుబాటులో లేవు.",

  // COMMON
  shareTemple: "ఈ దేవాలయాన్ని పంచుకోండి",
  copied: "నకలు చేయబడింది!",
  note: "గమనిక:",
  passwordNote:
    "మీ పాస్‌వర్డ్ విజయవంతంగా నవీకరించిన తర్వాత, భద్రత కారణాల వల్ల మీరు స్వయంచాలకంగా లాగిన్ పేజీకి తిరిగి పంపబడతారు. కొనసాగడానికి మీ కొత్త పాస్‌వర్డ్ ఉపయోగించి సైన్ ఇన్ చేయండి.",
};
export default Telugu;
